import React from 'react'

const Landing = (props) => (
    <section id="banner">
        <div className="inner">
            <header className="major">
                <h1>My Skills</h1>
            </header>
            <div className="content">
                <p></p>
            </div>
        </div>
    </section>
)

export default Landing